import { type ISupportedLanguage } from '#app/utils/i18n.tsx'

/**
 * Keys here are numbers because they come from the structure of data for the italians. They asked for these specific keys.
 */
export class ReasonForContact {
	static readonly MATERIAL_INFO = new ReasonForContact('material-info', 3, {
		en: 'Material Information',
		it: 'Informazioni Materiali',
		de: 'Materialinformationen',
		fr: 'Informations sur les matériaux',
		es: 'Información de materiales',
	})
	static readonly COLLAB_PROPOSAL = new ReasonForContact('collab', 6, {
		en: 'Collaboration Proposal',
		it: 'Proposta di collaborazione',
		de: 'Zusammenarbeitsvorschlag',
		fr: 'Proposition de collaboration',
		es: 'Propuesta de colaboración',
	})
	static readonly VISIT_REQUEST_OR_CONTACT = new ReasonForContact(
		'visit-or-contact',
		2,
		{
			en: 'Visit Request/Contact',
			it: 'Richiesta Visita/Contatto',
			de: 'Besuchsanfrage/Kontakt',
			fr: 'Demande de visite/Contact',
			es: 'Solicitud de visita/Contacto',
		},
	)
	static readonly DISTRIBUTION_AND_RETAIL = new ReasonForContact(
		'distribution-and-retail',
		2,
		{
			en: 'Distribution and Retailers',
			it: 'Distribuzione e Rivenditori',
			de: 'Distribution und Händler',
			fr: 'Distribution et revendeurs',
			es: 'Distribución',
		},
	)
	static readonly WEBSITE_ASSISTANCE = new ReasonForContact(
		'website-assistance',
		0,
		{
			en: 'Site Assistance',
			it: 'Assistenza Sito',
			de: 'Website-Unterstützung',
			fr: 'Assistance du site',
			es: 'Asistencia del sitio',
		},
	)
	static readonly CATALOG_REQUEST = new ReasonForContact('catalog-request', 5, {
		en: 'Catalog Request',
		it: 'Richiesta Catalogo',
		de: 'Kataloganfrage',
		fr: 'Demande de catalogue',
		es: 'Solicitud de catálogo',
	})

	private constructor(
		public readonly code: string,
		public readonly key: number,
		public readonly labels: {
			en: string
			it: string
			de: string
			fr: string
			es: string
		},
	) {}

	static getAll(): ReasonForContact[] {
		return [
			this.MATERIAL_INFO,
			this.COLLAB_PROPOSAL,
			this.VISIT_REQUEST_OR_CONTACT,
			this.DISTRIBUTION_AND_RETAIL,
			this.WEBSITE_ASSISTANCE,
			this.CATALOG_REQUEST,
		]
	}

	static getSelectOptions(locale: ISupportedLanguage): Array<{
		value: string
		label: string
	}> {
		return this.getAll().map((reason) => ({
			value: reason.code,
			label: reason.labels[locale],
		}))
	}

	static getByCode(code: string): ReasonForContact | undefined {
		return this.getAll().find((reason) => reason.code === code)
	}
}
